export default {
  drafts: [],
  lastUpdatedDraft: {},
  pageIndex: 0
}
